import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "nearbyDeviceFilled"
const NearbyDeviceFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 8.625C13.243 8.625 14.25 9.632 14.25 10.875S13.243 13.125 12 13.125 9.75 12.118 9.75 10.875 10.757 8.625 12 8.625" />
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M12 5.25C8.943 5.25 6.375 7.412 6.375 10.715 6.375 12.71 7.657 14.71 8.848 16.125 9.459 16.854 10.085 17.47 10.586 17.909 10.836 18.128 11.064 18.308 11.251 18.44 11.343 18.505 11.436 18.567 11.525 18.615 11.57 18.64 11.625 18.667 11.687 18.69 11.735 18.708 11.852 18.75 12 18.75S12.265 18.708 12.313 18.69Q12.407 18.653 12.475 18.615C12.564 18.567 12.657 18.505 12.749 18.44 12.936 18.31 13.164 18.127 13.414 17.908 13.915 17.47 14.54 16.853 15.152 16.126 16.342 14.71 17.625 12.71 17.625 10.715 17.625 7.412 15.057 5.25 12 5.25"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default NearbyDeviceFilledIcon
